import { NgModule } from '@angular/core';
import { SubsystemManager } from './subsystem-manager.service';

@NgModule({
  providers: [
    SubsystemManager
  ],
  imports: [
  ]
})
export class SubsystemManagementModule {
}
